import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const ocamlGenerator: LanguageGenerator = {
  id: 'ocaml',
  name: 'OCaml',
  category: 'request-examples',
  color: '#EC6813',
  generate(config: ExportConfig): GeneratedFile[] {
    const requestBlocks = config.apps
      .flatMap((a) =>
        a.templates.map((t) => {
          const exampleJson = JSON.stringify({
            template_slug: t.slug,
            recipient: 'user@example.com',
            data: t.schema
              ? t.schema.reduce<Record<string, unknown>>((acc, f) => {
                  acc[f.key] = f.type === 'number' ? Number(f.example || 0) : f.type === 'boolean' ? true : (f.example || f.key);
                  return acc;
                }, {})
              : {},
          });
          return [
            `(* Send: ${t.name} *)`,
            `let () =`,
            `  let body = {|${exampleJson}|} in`,
            `  let headers = Cohttp.Header.of_list [`,
            `    ("Content-Type", "application/json");`,
            `    ("X-API-KEY", ${a.key}_key);`,
            `  ] in`,
            `  let uri = Uri.of_string (service_url ^ "/v1/send") in`,
            `  let body_str = Cohttp_lwt.Body.of_string body in`,
            `  let _resp, body = Lwt_main.run (Cohttp_lwt_unix.Client.post ~headers ~body:body_str uri) in`,
            `  let resp_str = Lwt_main.run (Cohttp_lwt.Body.to_string body) in`,
            `  print_endline resp_str`,
          ].join('\n');
        }),
      )
      .join('\n\n');

    const keyDecls = config.apps
      .map((a) => `let ${a.key}_key = Sys.getenv "${a.envVarName}"`)
      .join('\n');

    const content = `(* mail_requests.ml — generated by Mail Service SDK Export *)
(* Requires: cohttp-lwt-unix  opam install cohttp-lwt-unix *)
open Cohttp
open Cohttp_lwt_unix

let service_url = Sys.getenv "${config.serviceUrlVarName}"
${keyDecls}

${requestBlocks}
`;

    return [
      { filename: 'mail_requests.ml', content, syntax: 'ocaml' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
